/**
 * Pregame View Controller.
 * @requires  GameDayUI.LineupsViewController
 */
define('responsive-gameday/controllers/PregameViewController',['require','exports','module','Responsive/controllers/ScrollViewController','responsive-gameday-tracking/responsive-gameday-tracking','../views/render/PregameViewRender','message-service/message-service','Responsive/util/renderComplete','gameday-index-url-hasher/enums/HashEvents','../views/Monitor/Events/ViewModelUpdateEvents','gameday-device-interaction/gameday-device-interaction','jquery','FitText.js/jquery.fittext'],function(require,exports,module){
	var ScrollViewController  = require( 'Responsive/controllers/ScrollViewController' ),
        Tracking = require("responsive-gameday-tracking/responsive-gameday-tracking"),
        PregameViewRender = require( '../views/render/PregameViewRender' ),		
		MessageService = require("message-service/message-service"),
		renderComplete = require( 'Responsive/util/renderComplete' ),
		HashEvents = require("gameday-index-url-hasher/enums/HashEvents"),
		VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
		DeviceInteraction = require( "gameday-device-interaction/gameday-device-interaction" ),
		$ = require('jquery'),
		fitText = require('FitText.js/jquery.fittext');

	// Add private variables here
	var Superclass,
		pregameSectionElement;

	// Add private methods here

	function onBeat(data, evt) {
		var that = this;
		if(!data.pregame.hasLineups){
			data.pregame.activeViewType = 1;
		} else {
			data.pregame.activeViewType = ~~this.viewRender.viewState.activeViewType;
		}
		data.pregame.activeStatType = ~~this.viewRender.viewState.activeStatType;
		that.childWrapper.innerHTML = this.viewRender.render(data);

		renderComplete(function () {
			that.content = that.getView().querySelector('.pregamematchup');
			that.hideOverlay();
			that.setScroll(that.getView());
			that.getView().setAttribute('data-loading',false);
			that.viewRender.toggleStatcastDefinitions(~~that.viewRender.viewState.activeStatType);
			jQuery('.header',that.vew).fitText(1.5,{
                maxFontSize : 32
            });
		});
	}

	// Constructor
	function PregameViewController(type) {
		// Call super constructor
		Superclass.constructor.call(this);
		this.viewRender = new PregameViewRender();
		this.data = {active: 0};
		this.type = type;
		this.viewRender.viewState.activeViewType = 0;
		this.viewRender.viewState.activeStatType = 0;
		this.activeClassName = "active";
		this.onBeat=function(payload, evt) {
            onBeat.call(this,payload,evt);
        };
	}

	// Prototype Inheritence
	ScrollViewController.spawn(PregameViewController).define({
		loadView: function () {
			var that = this;

			Superclass.loadView.call(this);
			this.setScrollOpts({
				horizontal : false
			});
			this.setClassName("PregameViewController");
			this.content = null;
			this.showOverlay();
			MessageService.addListener(HashEvents.GAME_ID_CHANGED, function() {
				that.showOverlay();
			});
			$(this.getView()).on('click', 'a[data-jsurl]',function (e) {
				return true;
			}).on('click touchstart', '.promos a[target]', function (e) {
				var deviceInteraction = DeviceInteraction.get(),
					target = e.target;

				var shouldPreventDefault = deviceInteraction.webview({
					url : target.href
				});
				if(shouldPreventDefault){
					e.preventDefault();
				}
				return !shouldPreventDefault;
			}).on('click', 'nav.secondary.view-type li', function (e) {
				var el = this;
				that.defaultSwitch = false;
				e.preventDefault();
				e.stopPropagation();
				that.content.setAttribute('data-view-type', that.viewRender.viewState.activeViewType = el.getAttribute('data-view-type'));
				// set stat type too only if its present on navi item
				that.viewRender.handleMatchupToggle(that.content, ~~that.viewRender.viewState.activeViewType);
				that.setScroll();
			}).on('click', 'nav.sub.stat-type li', function (e) {
				var el = this;
				that.defaultSwitch = false;
				e.preventDefault();
				e.stopPropagation();
				that.content.setAttribute('data-stat-type', that.viewRender.viewState.activeStatType = el.getAttribute('data-stat-type'));
				that.viewRender.toggleStatcastDefinitions(~~that.viewRender.viewState.activeStatType);
				that.setScroll();
			});
		},

		viewWillAppear: function () {
			var that = this;
			this.showOverlay();
			MessageService.addListener.call(that, VMEvents.UPDATE_PREGAME, that.onBeat);
			Superclass.viewWillAppear.call(this);
			Tracking.track_pregame_tab_launch();
		},

		viewWillDisappear: function () {
			MessageService.removeListener(VMEvents.UPDATE_PREGAME, this.onBeat);
			Superclass.viewWillDisappear.call(this);
		},
		viewDidAppear: function() {
			var that = this;
			Superclass.viewDidAppear.call(this);
			MessageService.publish(VMEvents.REQUEST_PREGAME_DATA);
		}	
	});

	Superclass = PregameViewController.superclass;
	return PregameViewController;
});
